import StackedBarChart from '../../components/admin/StackedBarChart';
import useAdminData from './useAdminData';
import { fetchReassignmentsSeries, fetchActionsByAgent } from '../../services/adminStatsService';

export default function AdminAudit() {
  const reassign = useAdminData(fetchReassignmentsSeries);
  const actions = useAdminData(fetchActionsByAgent);

  const pivoted = pivotBySource(reassign.data?.data || []);

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Agent assignments per day (by source)</h3>
        {reassign.loading ? <Loading /> : reassign.error ? <Err msg={reassign.error} /> : (
          <StackedBarChart
            data={pivoted.rows}
            xKey="bucketLabel"
            stacks={pivoted.sources.map((s) => ({ key: s, label: s }))}
          />
        )}
      </div>

      <div className="bg-white rounded-lg border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 px-4 py-3 border-b border-gray-200">
          Actions by agent
        </h3>
        {actions.loading ? <Loading /> : actions.error ? <Err msg={actions.error} /> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Agent</th>
                <th className="px-3 py-2 text-left">Action</th>
                <th className="px-3 py-2 text-right">Count</th>
              </tr>
            </thead>
            <tbody>
              {(actions.data?.data || []).map((r, i) => (
                <tr key={`${r.userId}-${r.action}-${i}`} className="border-t border-gray-100">
                  <td className="px-3 py-2">{r.name}</td>
                  <td className="px-3 py-2 font-mono text-xs">{r.action}</td>
                  <td className="px-3 py-2 text-right">{r.count.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function pivotBySource(rows) {
  const byBucket = new Map();
  const sources = new Set();
  rows.forEach(({ bucket, source, count }) => {
    sources.add(source);
    const key = String(bucket);
    if (!byBucket.has(key)) byBucket.set(key, { bucket, bucketLabel: new Date(bucket).toISOString().slice(0, 10) });
    byBucket.get(key)[source] = count;
  });
  return {
    rows: Array.from(byBucket.values()).sort((a, b) => new Date(a.bucket) - new Date(b.bucket)),
    sources: Array.from(sources),
  };
}

function Loading() {
  return <div className="text-gray-500 text-sm p-4">Loading…</div>;
}
function Err({ msg }) {
  return <div className="text-red-600 text-sm p-4">{msg}</div>;
}
